import { PieChart } from '@mui/x-charts/PieChart';
import { Box, Typography } from '@mui/material';

interface DonutChartProps {
    data?: Array<{ id: number; value: number; label: string; color?: string }>;
    title?: string;
    innerRadius?: number;
    outerRadius?: number;
    width?: number;
    height?: number;
    showLegend?: boolean;
}

export default function DonutChart({
    data = [
        { id: 0, value: 10000, label: 'Hoàn thành', color: '#20DF75' },
        { id: 1, value: 5000, label: 'Thất bại', color: '#FF4655' },
        { id: 1, value: 5000, label: 'Đã hủy', color: '#CFCFCF' },
        { id: 2, value: 8000, label: 'Đang thực hiện', color: '#0866FF' },
    ],
    title = '',
    innerRadius = 60,
    outerRadius = 85,
    width = 190, // Minimum: outerRadius * 2 + margins
    height = 190,
    showLegend = false,
}: DonutChartProps) {
    // Tính tổng từ data
    const total = data.reduce((sum, item) => sum + item.value, 0);

    return (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {/* Donut Chart */}
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                <PieChart
                    series={[
                        {
                            data: data,
                            innerRadius: innerRadius,
                            outerRadius: outerRadius,
                            paddingAngle: 1,
                            cornerRadius: 4,
                            highlightScope: { faded: 'global', highlighted: 'item' },
                            cx: width / 2, // Center X
                            cy: height / 2, // Center Y
                        },
                    ]}
                    width={width}
                    height={height}
                    margin={{ top: 0, bottom: 0, left: 0, right: 0 }}
                    sx={{
                        '& .MuiChartsLegend-root': {
                            display: showLegend ? 'block' : 'none',
                        },
                        '& .MuiChartsLegend-series text': {
                            fontSize: '12px !important',
                            fontWeight: 500,
                        },
                    }}
                />

                {/* Center Text - Total */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center',
                        pointerEvents: 'none',
                        zIndex: 1,
                    }}
                >
                    <Typography sx={{ fontSize: '36px', fontWeight: 'bold', color: '#000' }}>
                        {total.toLocaleString()}
                    </Typography>
                    <Typography sx={{ fontSize: '14px', fontWeight: 'bold', color: '#000000' }}>
                        Toàn bộ
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}